// context/GlobalProvider.js

import { DashboardProvider } from "./DashboardContext";


export const GlobalProvider = ({ children }) => {
  return (
  
        <DashboardProvider>
          {children}
        </DashboardProvider>
  );
};